import { useState } from 'react';
import clsx from 'clsx';

import iconUtilities from '@atom/utilities/iconUtilities';

import FhwaSchemaElementListRow from './FhwaSchemaElementListRow';

import classes from './elements.module.css';

const RIGHT_ARROW = 'right-arrow';
const DOWN_ARROW = 'down-arrow';
const VISIBLE = 'inherit';
const HIDDEN = 'none';

interface ElementGroup {
  name: string;
  elements: any[];
}

interface Props {
  elementGroup: ElementGroup;
  selectedItems: Set<string>;
  schemaQuantities: object;
  onClick: (id?: string) => any;
  elementGroupIndex?: number;
  loadingSchemaTreeNode: boolean;
  elementExistsOnAsset?: boolean;
  inventorySchemaActions?: any;
}

const FhwaSchemaElementGroupSection = ({
  elementGroup,
  selectedItems,
  onClick,
  schemaQuantities,
  elementGroupIndex,
  loadingSchemaTreeNode,
  elementExistsOnAsset,
}: Props) => {
  const [icon, setIcon] = useState(iconUtilities.leftIcon(RIGHT_ARROW));
  const [expanded, setExpanded] = useState(HIDDEN);

  const toggleSection = () => {
    if (expanded === HIDDEN) {
      setIcon(iconUtilities.leftIcon(DOWN_ARROW));
      setExpanded(VISIBLE);
    } else {
      setIcon(iconUtilities.leftIcon(RIGHT_ARROW));
      setExpanded(HIDDEN);
    }
  };

  return (
    <div>
      <div
        className={clsx(classes.groupContainer, classes.modal)}
        onClick={toggleSection}
      >
        <div className={classes.groupIcon}>{icon}</div>
        <div className={classes.groupLabel}>{elementGroup.name}</div>
      </div>
      <div
        className={classes.elementListContainer}
        style={{ display: expanded }}
      >
        {elementGroup.elements.map((element, elementIndex) => (
          <FhwaSchemaElementListRow
            isChecked={selectedItems.has(element.id)}
            loading={loadingSchemaTreeNode}
            key={element.id}
            element={element}
            value={schemaQuantities[element.id]}
            selectedItems={selectedItems}
            schemaQuantities={schemaQuantities}
            onClick={onClick}
            elementPath={[
              'elementGroups',
              elementGroupIndex,
              'elements',
              elementIndex,
            ]}
            elementExistsOnAsset={elementExistsOnAsset}
          />
        ))}
      </div>
    </div>
  );
};

export default FhwaSchemaElementGroupSection;
